const options = {
  5: "bg-purple-800/5",
  10: "bg-purple-800/10",
  25: "bg-purple-800/25",
  50: "bg-purple-800/50",
  75: "bg-purple-800/75",
  90: "bg-purple-800/90",
  100: "bg-purple-800",
};

const from = {
  5: "from-purple-800/5",
  10: "from-purple-800/10",
  25: "from-purple-800/25",
  50: "from-purple-800/50",
  75: "from-purple-800/75",
  90: "from-purple-800/90",
  100: "from-purple-800",
};

export default function getBackgroundPurple800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
